import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { animatedStyle } from '@css/styles';
import { darkBlue, lightBlue, white } from '@css/constants';
import { FontNormal } from '@css/fonts';
import { fontSize } from "@css/styles";

const focusPaddingSize = '1px';

type Props = {
  inverted?: boolean
}

export const StyledLink = styled('a')<Props>(props => css`
  -webkit-appearance: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  ${animatedStyle}
  ${FontNormal(600)}
  ${fontSize(16)}
  appearance: none;
  background: transparent;
  border: 1px solid transparent;
  color: ${props.inverted ? white : lightBlue} !important;
  cursor: pointer;
  display: inline-block;
  font-family: inherit;
  margin: 0;
  outline: none;
  padding: 0;
  position: relative;
  text-align: center;
  text-decoration: underline;
  touch-action: manipulation;
  transition: all 0.2s ease;
  user-select: none;
  white-space: nowrap;

  &:hover {
    border-color: transparent;
    color: ${props.inverted ? white : darkBlue};
    text-decoration: none;
  }

  &:active {
    opacity: 0.8;
    background: transparent;
  }

  &:focus::before {
    content: "";
    border-bottom: 1px solid currentcolor;
    height: 0;
    pointer-events: none;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 1.2rem;

    margin-left: calc(${focusPaddingSize} * -2);
    margin-top: calc(${focusPaddingSize} * -2);
    padding: ${focusPaddingSize};
    width: calc(100% + ${focusPaddingSize} * 2);
  }
`);
